export class ApiUrl {
  /**
   * ApiUrl() gives the endpoint for the web api
   */
  public static webapiurl() {
    switch (window.location.host) {
      case 'liravalidations.wser.wur.nl':
        return 'https://liravalidations.wser.wur.nl/WebApi'
      case 'acc.liravalidations.wser.wur.nl':
        return 'https://acc.liravalidations.wser.wur.nl/WebApi'
      case 'tst.liravalidations.wser.wur.nl':
        return 'https://tst.liravalidations.wser.wur.nl/WebApi'
      default:
        return 'https://localhost:44365'
    }
  }
}
